module.exports = __webpack_public_path__ + "img/social-networks.b0a09d54.svg";